import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './shared/components/layout/Layout';
import GlobalProgressBar from './shared/components/GlobalProgressBar';
import {
  AuthProvider,
  ProtectedRoute,
  RequireProjectAccess,
  CalibrationsRoute,
  AdminRoute,
  LoginPage,
  UnauthorizedPage,
} from './features/auth';
import { Dashboard } from './features/dashboard';
import CalibrationManagement from './features/calibration/pages/CalibrationManagement';
import CalibrationDetailsPage from './features/calibration/pages/CalibrationDetailsPage';
import StartCalibrationPage from './features/calibration/pages/StartCalibrationPage';
import BulkCalibrationPage from './features/calibration/pages/BulkCalibrationPage';
import ManageAcceptanceCriteria from './features/manage/pages/ManageAcceptanceCriteria';
import ManageDailyEnvironmentalData from './features/manage/pages/ManageDailyEnvironmentalData';
import { ModalProvider } from './shared/components/providers/ModalContext';
import NotFound from './shared/components/NotFound';

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <Router>
          <div className="App">
            <GlobalProgressBar />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <RequireProjectAccess>
                      <Layout />
                    </RequireProjectAccess>
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route
                  path="calibrations"
                  element={
                    <CalibrationsRoute>
                      <CalibrationManagement />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path="calibrations/start"
                  element={
                    <CalibrationsRoute>
                      <StartCalibrationPage />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path="calibrations/bulk-start"
                  element={
                    <CalibrationsRoute>
                      <BulkCalibrationPage />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path="calibrations/details"
                  element={
                    <CalibrationsRoute>
                      <CalibrationDetailsPage />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path="manage/acceptance-criteria"
                  element={
                    <AdminRoute>
                      <ManageAcceptanceCriteria />
                    </AdminRoute>
                  }
                />
                <Route
                  path="manage/daily-environmental-data"
                  element={
                    <AdminRoute>
                      <ManageDailyEnvironmentalData />
                    </AdminRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
            <Toaster
              position="top-right"
              containerStyle={{ zIndex: 99999 }}
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
              }}
            />
          </div>
        </Router>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
